import React from 'react';
import './MarketingSection.css';

const steps = [
  {
    title: 'Market Research',
    description: 'In-depth analysis to understand your audience and competitors.'
  },
  {
    title: 'Brand Strategy',
    description: 'Crafting a unique identity and positioning for your brand.'
  },
  {
    title: 'Digital Campaigns',
    description: 'Executing creative campaigns across digital channels.'
  },
  {
    title: 'Analytics & Optimization',
    description: 'Measuring results and refining strategies for maximum impact.'
  }
];

function MarketingSection() {
  // Card positions and tops for longer wave, start and end points further apart
  const svgWidth = 2400;
  const svgHeight = 400;
  // X positions: start, first bend, second bend, end (spread out)
  const cardPositions = [190, 800, 1600, 2200];
  // Y positions: start, first bend (up), second bend (down), end
  const cardTops = [100, 50, 52, 100];

  // SVG wave path: 2 bends, step-by-step, longer start and end
  const pathD = `M 100 220 Q 450 40, 800 220 Q 1200 400, 1600 220 Q 1950 40, 2300 220`;

  return (
    <div className="roadmap-responsive" style={{paddingTop: '120px', position: 'relative', minHeight: '500px'}}>
      <h2 className="marketing-title" style={{position: 'absolute', top: '40px', left: '50%', transform: 'translateX(-50%)', width: '100%'}}>Your <span style={{color:'#00b894'}}>Marketing Roadmap with JN IT</span></h2>
      <svg className="roadmap-svg" viewBox={`0 0 ${svgWidth} ${svgHeight}`} width="100%" height={svgHeight} style={{position:'absolute', top:'120px', left:0, zIndex:0}}>
        <path d={pathD} stroke="#00b894" strokeWidth="8" fill="none" strokeDasharray="16 12">
          <animate attributeName="stroke-dashoffset" from="80" to="0" dur="2s" repeatCount="indefinite" />
        </path>
      </svg>
      <div className="roadmap-cards" style={{position:'relative', zIndex:1}}>
        {steps.map((step, idx) => (
          <div
            key={step.title}
            className="roadmap-card"
            style={{ left: `calc(${(cardPositions[idx] / svgWidth) * 100}% - 120px)`, top: `${cardTops[idx]}px`, width: '240px', padding: '28px 20px', position: 'absolute', textAlign: 'center' }}
          >
            <div className="roadmap-card-circle">{idx + 1}</div>
            <div className="roadmap-card-title">{step.title}</div>
            <div className="roadmap-card-desc">{step.description}</div>
          </div>
        ))}
      </div>
      <div style={{width:'100%', textAlign:'center', marginTop:'60px'}}>
        <button className="explore-btn">
          Explore Now
        </button>
      </div>
    </div>
  );
};

export default MarketingSection;
